import React from "react";
import {useAuthToken, useIsLoggedIn, useRedirectIfNotSubscribed} from "../hooks/auth";
import { Grid } from "@mui/material";
import PodcastsSection from "../components/podcastsSection/PodcastsSection";
import EventsSection from "../components/eventsSection/EventsSection";
import Ambitions from "../components/home/Ambitions";
import FindSupport from "../components/home/FindSupport";
import Socials from "../components/home/Socials";
import CultivateSynergies from "../components/home/CultivateSynergies";
import ProProfile from "../components/home/ProProfile";
import {useGetProInformationQuery} from "../store/api/user";

const PrivateSpace = () => {
  useRedirectIfNotSubscribed();
  const [proInfos, setProInfos] = React.useState(null);

  const authToken = useAuthToken();
  const { data = null, refetch } =  useGetProInformationQuery(
    { authToken },
    { skip: !authToken }
  );

  React.useEffect(() => {
    if(data ){
      setProInfos(data);
    }
  }, [data])

  // 1. Créer une référence pour l'élément cible
  const sectionProfileRef = React.useRef(null);
  // 2. Fonction qui déclenche le défilement
  const handleScrollProfile = () => {
    sectionProfileRef.current?.scrollIntoView({ 
      behavior: 'smooth', // Rend le scroll fluide
      block: 'start'      // Aligne le haut de l'élément avec le haut de l'écran
    });
  };

  return (
    <Grid
      container
      sx={{
        background: "white",
        width: "100%",
        minWidth: "100%",
        overflow: "hidden",
      }}
    >
      <PodcastsSection proInfos={proInfos} handleScrollProfile={handleScrollProfile}/>
      <EventsSection proInfos={proInfos} />
      {proInfos && (<ProProfile proInfos={proInfos} refetch={refetch} sectionProfileRef={sectionProfileRef} />)}
      <CultivateSynergies />
      <Ambitions />
      {/*<Podcasts />*/}
      {/*<Magazine />*/}
      <Socials />
    </Grid>
  );
};

export default PrivateSpace;
